import React from 'react';
import { Box, Typography, Stack, Link } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { ReactComponent as XpIcon } from '../../assets/icons/xp.svg';
import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';

const GameCard = ({ game, onEdit, shouldEdit, shouldDelete, onDelete }) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                paddingX: 6,
                paddingY: 4,
                backgroundColor: '#fff',
                minWidth: '374px',
            }}
        >
            <Typography
                variant="body1"
                gutterBottom
                sx={{ fontSize: '20px', color: '#292929', mb: 2 }}
            >
                {game.name}
            </Typography>
            <Stack direction="row" gap={1}>
                <Typography variant="body2" sx={{ color: '#666666', mb: 2 }}>
                    Pontuação:
                </Typography>
                <XpIcon />
                <CoinIcon />
            </Stack>
            <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                {shouldEdit && (
                    <Link
                        component="button"
                        underline="none"
                        onClick={() => onEdit(game)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#1F83FF',
                        }}
                    >
                        <EditIcon />
                        <Typography variant="body2" sx={{ ml: 0.5 }}>
                            Editar
                        </Typography>
                    </Link>
                )}
                {shouldDelete && (
                    <Link
                        component="button"
                        underline="none"
                        onClick={() => onDelete(game)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#1F83FF',
                        }}
                    >
                        <DeleteOutlinedIcon fontSize="small" />
                        <Typography variant="body2" sx={{ ml: 0.5 }}>
                            Excluir
                        </Typography>
                    </Link>
                )}
            </Stack>
        </Box>
    );
};

export default GameCard;
